export interface PromotionInterface {
    id: string;
    code: string;
    description?: string;
    termsAndConditions?: string[];
    enabled: boolean;
    discount: number;
    discountType: "percent" | "absolute";
    startDate?: Date;
    endDate?: Date;
    minPurchaseAmount: number;
    maxDiscountAmount?: number;
    eligibleGigs?: string[];
    eligibleCategories?: string[];
    eligibleSubcategories?: string[];
    usageLimit?: number;
    userLimit?: number;
    timesUsed: number;
    applicableForNewUsersOnly: boolean;
    customRules?: any;
    createdAt?: Date;
    updatedAt?: Date;
  }
  
  export class Promotion implements PromotionInterface {
    id: string;
    code: string;
    description?: string;
    termsAndConditions?: string[];
    enabled: boolean;
    discount: number;
    discountType: "percent" | "absolute";
    startDate?: Date;
    endDate?: Date;
    minPurchaseAmount: number;
    maxDiscountAmount?: number;
    eligibleGigs?: string[];
    eligibleCategories?: string[];
    eligibleSubcategories?: string[];
    usageLimit?: number;
    userLimit?: number;
    timesUsed: number;
    applicableForNewUsersOnly: boolean;
    customRules?: any;
    createdAt?: Date;
    updatedAt?: Date;
  
    constructor(jsonData: any) {
      this.id = jsonData._id;
      this.code = jsonData.code;
      this.description = jsonData.description;
      this.termsAndConditions = jsonData.termsAndConditions;
      this.enabled = jsonData.enabled ?? true;
      this.discount = jsonData.discount ?? 0;
      this.discountType = jsonData.discountType ?? "percent";
      this.startDate = jsonData.startDate ? new Date(jsonData.startDate) : undefined;
      this.endDate = jsonData.endDate ? new Date(jsonData.endDate) : undefined;
      this.minPurchaseAmount = jsonData.minPurchaseAmount ?? 0;
      this.maxDiscountAmount = jsonData.maxDiscountAmount;
      this.eligibleGigs = jsonData.eligibleGigs?.map((id: any) => id.toString());
      this.eligibleCategories = jsonData.eligibleCategories?.map((id: any) => id.toString());
      this.eligibleSubcategories = jsonData.eligibleSubcategories?.map((id: any) => id.toString());
      this.usageLimit = jsonData.usageLimit;
      this.userLimit = jsonData.userLimit;
      this.timesUsed = jsonData.timesUsed ?? 0;
      this.applicableForNewUsersOnly = jsonData.applicableForNewUsersOnly ?? false;
      this.customRules = jsonData.customRules;
      this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
      this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
    }
  }
  